import { Component, OnInit, Input } from '@angular/core';
import { MatDivider, MatDividerModule } from "@angular/material/divider";
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-report-overall-grades',
  standalone: true,
  templateUrl: './report-overall-grades.component.html',
  styleUrls: ['./report-overall-grades.component.css'],
  imports: [MatDividerModule, TranslatePipe]
})
export class ReportOverallGradesComponent implements OnInit {
  @Input() CapacityText: string | null | undefined;
  @Input() Capacity: number | null | undefined;
  @Input() GamePerformanceText: string;
  @Input() GamePerformance: number;
  @Input() TotalQualityText: string;
  @Input() TotalQuality: number;
  @Input() PlayerTypeText: string | null | undefined;
  @Input() PlayerType: number | null | undefined;
  @Input() CurrentLevelRankingText: string | null | undefined;
  @Input() CurrentLevelRanking: number | null | undefined;
  @Input() PositionText: string | null | undefined;
  @Input() PositionId: number | null | undefined;

  classesRankingBox: string[] = ['grayshading','redshading','yellowshading', 'greenshading', 'lightgreenshading','blueshading' ];
  classesRankingBoxCapacity: string[] = ['grayshading','redshading','yellowshading', 'yellowshading', 'yellowshading','greenshading','greenshading','greenshading' ];
  classesRankingBoxProjection: string[] = ['grayshading','redshading','yellowshading', 'yellowshading', 'greenshading','greenshading','greenshading','greenshading','greenshading' ];


  constructor() { }

  ngOnInit() {
  }

  floor(Value:number): number{
    return Math.floor(Value);
  }

}
